import { render } from "./TotalPayout.vue?vue&type=template&id=285db9d8&scoped=true"
import script from "./TotalPayout.vue?vue&type=script&lang=js"
export * from "./TotalPayout.vue?vue&type=script&lang=js"

import "./TotalPayout.vue?vue&type=style&index=0&id=285db9d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285db9d8"]])

export default __exports__